import React from 'react'
import { css, useTheme } from '@emotion/react'


function AddressIcon({icon, content}) {
    const theme = useTheme()
    const style = css`
        display: flex;
        padding: 0.5rem 0;
        align-items: center;
        gap: 1rem;
        svg {
            font-size: 28px;
            line-height: 28px;
            color: ${theme.colors.primary};
            font-weight: 100;
        }
        .content {
            font-weight: 600;
            color: ${theme.colors.secGray};
        }
    `
    return (
        <div css={style}>
            {icon}
            <div className="content">{content}</div>
        </div>
    )
}

export default AddressIcon